import {computed} from "mobx";
import {BaseModuleState} from "../../../../../infrastructure/models/base-module-state";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../../../core/managers/navigation-manager";
import {AppStore} from "../../../../../core/app/app-store";
import {LoggerUtils} from "../../../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {TermsUtils} from "../../../../../infrastructure/utils/terms-utils";
import {CompetitionBracketsPageConfig} from "../competition-brackets-page.config";
import type {PartialGameDomainModel} from "../../../../../domain/partial-game/models/partial-game-domain-model";

export class CompetitionBracketsPageState extends BaseModuleState {
  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, CompetitionBracketsPageConfig];

  @computed get competitionId(): Number {
    return Number(this.currentLinkModel?.params.key.split('-')?.last())
  }

  @computed get gameContext(): PartialGameDomainModel {
    return this.appState.context.game
  }
}
